import { render, staticRenderFns } from "./AssignShipment.vue?vue&type=template&id=60fcf7a2&"
import script from "./AssignShipment.vue?vue&type=script&lang=js&"
export * from "./AssignShipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports